<template>
    <div class="kefupage">
        <div v-if="showOut" @click="showKefu = true" class="kefubox flex-column-between point">
            <img class="kficon" src="@/assets/index/kefuicon.png" alt="">
            <div class="fs14 colorfff">如需购买/咨询 请联系客服 </div>
        </div>
        <el-dialog title="联系客服" :visible.sync="showKefu" width="22%" top="25vh" center>
            <div class="kefuinfobox">
                <div>
                    <img class="codeimg" :src="appInfo.customer_service_code" alt="">
                    <div class="fs18 color999 mb23">扫码添加客服微信 </div>
                    <div class="fs18 mb28">客服电话：<span style="color: #319AFD;">{{ appInfo.customer_service_mobile
                            }}</span> </div>
                    <div class="flex-center">
                        <div class="kefubtn flex-center point">联系在线客服</div>
                    </div>
                </div>

            </div>

        </el-dialog>
    </div>

</template>
<script>


export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        showOut: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showKefu: false,
            kefuInfo: {}
        }
    },
    watch: {
        isShow: function (val) {
            this.showKefu = val
        },
        showKefu: function (val) {
            this.$emit('changeShow', val)
        }
    },
    mounted() {
        this.getAppInfo()

    },
    methods: {
    }

}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
    border-radius: 20px;
}

.kefuinfobox {
    background: #fff;
    text-align: center;
    border-radius: 20px;

    .kefubtn {
        width: 142px;
        height: 44px;
        background: #218FFE;
        border-radius: 22px;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
    }

    .codeimg {
        width: 188px;
        height: 188px;
        margin-bottom: 22px;
    }
}

.kefupage {


    .kefubox {
        background: #218FFE;
        width: 108px;
        height: 144px;
        border-radius: 15px;
        padding: 10px;
        position: fixed;
        right: 22px;
        top: 40%;
        align-items: center;
        // top: 50%;
        // transform: translateY(-50%);

        // &:hover {
        //     animation: flipInY;
        //     animation-duration: 0.9s;
        // }

        .kficon {
            width: 76px;
            height: 76px;
        }
    }
}
</style>
